module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAAJ1BMVEUAAAAeHh4XFxcZGRkaGhoYGBgZGRkaGhoYGBgZGRkaGhoZGRkZGRkz0pOeAAAADXRSTlMAESIzRFVmd4iZqrvMR+pJ2gAAAIdJREFUGNNjYAADQQYEsDhz5kwzjKO9TICBMWsThMO+BUx5F4CpSqiS6WCpCVAeJ0hSG8RyAREgnWBdoWCdDAzMC+A8LgMGjgQ4j62BgUcAzmM8wMDDAOcxHGCQYWBwDQ0tDw0NYWA4iMZDVYlqCqoNqLajugzN1ag+QvUtWkighhJaCCJCFwBIBSaFm8hl6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/plus.png
// module id = 664
// module chunks = 0